"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 3H2v18h20V3zm-8.43 8.1167c-.408-.2-.872-.3-1.392-.3-.28 0-.5.016-.66.048-.152.024-.296.048-.432.072l.156-1.68h3.06v-1.536H9.658l-.324 4.368.72.384c.16-.04.36-.08.6-.12.24-.048.472-.072.696-.072 1.144 0 1.716.432 1.716 1.296 0 .464-.144.808-.432 1.032-.28.216-.688.324-1.224.324-.368 0-.76-.052-1.176-.156-.416-.112-.772-.244-1.068-.396v1.56c.296.152.64.268 1.032.348.4.08.824.12 1.272.12 1.128 0 1.98-.264 2.556-.792.576-.536.864-1.268.864-2.196 0-.568-.12-1.044-.36-1.428-.232-.384-.552-.676-.96-.876z"
  })];
};

exports.default = _default;